<template>
    <v-dialog persistent v-model="cancelModal" width="500">
        <v-card>
            <v-card-title class="headline red lighten-1 white--text" default-title>Cancel Visa</v-card-title>
            <v-card-text class="pa-0">
                <v-container grid-list-md>
                    <v-layout wrap>
                        <form-error-display-handler :errors="errors"/>
                        <v-flex xs12>
                            <v-form ref="cancelForm" v-model="valid" lazy-validation class="px-2">
                                <v-textarea
                                    label="Remarks *"
                                    :rules="[rules.required]"
                                    outlined
                                    v-model="cancelForm.remarks"
                                />
                                <multiple-file-upload
                                    label="Remarks file"
                                    v-model="cancelForm.files"
                                />
                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn
                    color="red lighten-1"
                    class="white--text"
                    @click="closeModal"
                >Close
                </v-btn>
                <v-btn color="blue darken-3" :loading="loading" class="white--text" @click="cancel">Submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import {mapActions} from "vuex";
    import {validationMixin} from "../../mixins/validationMixin";
    import FormErrorDisplayHandler from "../FormErrorDisplayHandler";
    import FileInput from "../FileInput";
    import MultipleFileUpload from "../MultipleFileUpload";

    export default {
        data: () => ({
            valid: true,
            cancelForm: {},
            errors: [],
            loading: false
        }),
        components: {
            FormErrorDisplayHandler,
            FileInput,
            MultipleFileUpload
        },
        mixins: [validationMixin],
        computed: {
            cancelModal: {
                get() {
                    return this.$store.state.VisaRequestSingle.cancelModal;
                },
                set(value) {
                    this.$store.commit("VisaRequestSingle/setCancelModal", value);
                }
            },
        },
        methods: {
            ...mapActions("VisaRequestSingle", ["cancelRequest"]),
            cancel() {
                if (this.$refs.cancelForm.validate()) {
                    // this.loading = true;
                    let formData = new FormData();
                    formData.set('remarks', this.cancelForm.remarks);
                    formData.set('file', this.cancelForm.file);
                    let files = this.cancelForm.files;
                    if (files !== undefined) {
                        for (let i = 0; i < files.length; i++) {
                            formData.append(`files[${i}]`, files[i]);
                        }
                    }

                    this.cancelRequest(formData)
                        .then(res => {
                            this.form = false;
                            this.approveForm = {};
                            this.errors = null;
                            this.cancelModal = false;
                            this.loading = false;
                            this.$store.commit("Notification/showSuccess", 'Visa cancelled !!');
                        })
                        .catch(error => {

                            this.loading = false;
                            if (error.response.status === 422 || error.response.status === 400) {
                                this.errors = error.response.data.errors;
                            }
                        });
                } else {
                    this.$store.commit("Notification/showError", "Invalid Form Data");
                }
            },
            closeModal() {
                this.cancelModal = false;
                this.cancelForm = false
            }
        }
    };
</script>
